import { Routes, RouterModule } from '@angular/router';
import { RuleDefinitionComponent } from './ruledefinition.component';

const routes: Routes = [
    {
        path: '',
        component: RuleDefinitionComponent
    },
];

export const RuleDefinitionRoutes = RouterModule.forChild(routes);
